import { Body, Stack } from '@optimus-web/core';
import { EnterpriseProfilePrivilegesEnumNames } from '@mews-commander/legacy-data-structures';
import { useLocalizePrivilege } from '../PrivilegesTable/utils';

export const PrivilegeName = ({ privilege }: { privilege: EnterpriseProfilePrivilegesEnumNames }) => {
    const { label, hint } = useLocalizePrivilege()(privilege);

    return (
        <Stack vertical>
            <Body size="small">{label}</Body>
            {hint ? (
                <Body size="small" variant="secondary">
                    {hint}
                </Body>
            ) : null}
        </Stack>
    );
};
